import { ComponentType, Suspense, lazy, useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import Fallback from './components/Fallback';
import layout from './layout';
import { pwaReady } from './utils/pwa';

type Page = Record<
    string,
    {
        default: ComponentType;
    }
>;

const pages = import.meta.glob('./pages/**/*.tsx', { eager: true }) as Page;
const routes: {
    path: string;
    Element: React.ComponentType;
}[] = [];

Object.keys(pages).forEach((path) => {
    const fileName = path.match(/\.\/pages\/(.*)\.tsx$/)?.[1];
    if (!fileName) return;

    const normalizedPathName = fileName.replace('$', ':').replace(/\/index/, '');

    routes.push({
        path: fileName === 'index' ? '/' : `/${normalizedPathName.toLowerCase()}`,
        Element: layout(pages[path]?.default),
    });
});

routes.push({
    path: '*',
    Element: pages['./pages/404.tsx']?.default,
});

const router = createBrowserRouter(
    routes.map(({ Element, ...rest }) => ({
        ...rest,
        Component: lazy(() => Promise.resolve({ default: Element })),
    })),
    { basename: '/support' },
);

function App() {
    useEffect(() => {
        pwaReady();
    }, []);

    return (
        <Suspense fallback={<Fallback />}>
            <RouterProvider router={router} />
        </Suspense>
    );
}

export default App;
